import tw from "twin.macro"

export const TwErrorForm = tw.p`mt-2 text-sm text-red-600 transition duration-150 ease-in-out`
export const TwLableForm = tw.label`block text-xl font-medium text-center text-light-secondary mb-1 tracking-widest`
export const TwInput = tw.input`mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm transition duration-150 ease-in-out`
export const TwButton = tw.button`w-full bg-light-primary text-white py-2 rounded-md font-semibold hover:brightness-110`